import { Info } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/** Cartão com título (região nomeada pelo título), ação opcional à direita e nota de rodapé. */
export function Card({
  title,
  action,
  note,
  children,
  className,
}: {
  title?: string;
  action?: ReactNode;
  /** Aviso discreto no rodapé do card (ex.: moedas misturadas pela API). */
  note?: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <section
      aria-label={title}
      className={cn("min-w-0 rounded-card bg-surface p-5 shadow-card lg:p-6", className)}
    >
      {(title || action) && (
        <div className="mb-4 flex items-center justify-between gap-3">
          {title && <h2 className="m-0 text-[17px] font-semibold tracking-[-0.01em]">{title}</h2>}
          {action}
        </div>
      )}
      {children}
      {note && (
        <p className="m-0 mt-4 flex items-start gap-1.5 text-xs text-muted">
          <Info aria-hidden="true" className="mt-px size-3.5 shrink-0" />
          {note}
        </p>
      )}
    </section>
  );
}

export function PageHeader({ title, actions }: { title: string; actions?: ReactNode }) {
  return (
    <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
      <h1 className="m-0 text-2xl font-semibold tracking-[-0.02em] text-ink">{title}</h1>
      {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
    </div>
  );
}
